import { Grid, Step, StepConnector, StepLabel, Stepper, Theme, withStyles } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { QuitButton } from "components/Back";
import CancellationDialog from "components/CancelDialog/DialogCancellation";
import useText from "constants/text";
import { JobContext } from "contexts/JobContext";
import { HeaderContainer, TitleContainer } from "domains/Request/component/shared/MainStyles";
import { Order, Parcel } from "generated/graphql";
import { useCurrentUser } from "hooks";
import React from "react";
import { useNavigate } from "react-router-dom";
import { NewOrdersList } from "../../../Parcel/components/Orders/NewOrdersList";
import Airbills from "./Airbills";
import { ReacapJob } from "./JobRecap";
import NewJobInfos from "./NewJobInfos";
import { JobCreationStyles } from "./styles";

export const ColorlibConnector = withStyles((theme: Theme)=>({
  active: {
    "& $line": {
      backgroundColor: "#399ebf",
    },
  },
  completed: {
    "& $line": {
      backgroundColor: "#399ebf",
    },
  },
  line: {
    height: 2,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  }
}))(StepConnector);

const useParcelSteps = () => {
  const { text } = useText();
  return [`${text.parcel.pickup_dropoff_tab}`, `${text.all.client}`, `${text.all.recap}`];
};
export function JobLeftSide() {
  const styles = JobCreationStyles();
  const jobContext = React.useContext(JobContext);
  const { job, isUpdateJob, setJob, setIsUpdateJob } = jobContext;
  const [activeStep, setActiveStep] = React.useState(isUpdateJob ? 1 : 0);
  const [parcels, setParcels] = React.useState<Array<Parcel>>(null);
  const [openDialog, setOpenDialog] = React.useState(false);
  const { text } = useText();
  const steps = useParcelSteps();
  const navigation = useNavigate();
  const currentUser = useCurrentUser();

  React.useEffect(() => {
    if (job === null) {
      setIsUpdateJob(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ViewStep = React.useCallback(() => {
    switch (activeStep) {
      case 0:
        return <NewJobInfos onNext={setActiveStep} />;
      case 1:
        return <NewOrdersList onNext={setActiveStep} cancelUpdate={() => setOpenDialog(true)} />;
      case 2:
        return <ReacapJob activeStep={activeStep} setActiveStep={setActiveStep} setParcels={setParcels} />;
      case 3:
        return <Airbills setActiveStep={setActiveStep} parcels={parcels} />;
      default:
        return <NewJobInfos onNext={setActiveStep} />;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep, parcels]);

  const isOktoGoNext = () => {
    let isOk = true;
    const listorders: Order[] = job?.job_orders;
    if (!listorders || listorders?.length === 0) return false;
    listorders.forEach((element) => {
      if (
        element?.order_receiver?.receiver_address === undefined ||
        element?.order_receiver?.receiver_address === null ||
        element?.order_receiver?.receiver_address?.place_id === undefined ||
        element?.order_receiver?.receiver_address?.place_id === null ||
        element?.order_receiver?.receiver_address?.place_id?.length === 0
      ) {
        isOk = false;
        return false;
      }
      for (const el in element.order_receiver)
        if (
          (el !== "receiver_entreprise" &&
            el !== "receiver_specification_address" &&
            element?.order_receiver[el]?.length === 0) ||
          element?.order_receiver.receiver_phone_number?.length < 9
        ) {
          isOk = false;
          return false;
        }
      if (
        element?.order_receiver?.receiver_phone_number === "" ||
        element?.order_receiver?.receiver_phone_number === undefined ||
        element?.order_receiver?.receiver_phone_number === null
      ) {
        isOk = false;
        return false;
      }
      if (element.order_parcels.length === 0) {
        isOk = false;
        return false;
      }
      element?.order_parcels?.forEach((parcel: Parcel) => {
        for (const el in parcel)
          if (el !== "parcel_client_reference" && parcel[el]?.length === 0) {
            isOk = false;
            return false;
          }
      });
    });

    return isOk;
  };

  const onConfirmCancel = () => {
    setIsUpdateJob(false);
    setJob(null);
    navigation("/");
  };

  const handleQuit = () => {
    setOpenDialog(true);
  };
  const handleCloseModal = () => {
    setOpenDialog(false);
  };
  const handleClick = (index: any) => {
    if (index === 0 || isOktoGoNext()) {
      if (index !== 3) {
        setActiveStep(index);
      }
    }
  };
  return (
    <div className={styles.root}>
      <Grid container spacing={4}>
        <div className={styles.top}>
          <Grid item xs={12} spacing={2} className={styles.createJob}>
            <HeaderContainer>
              <QuitButton onClick={handleQuit} className={styles.quitButton} />
              <span className={styles.userName}>{text.all.new_parcels} :</span>{" "}
              <TitleContainer>
                <span className={styles.currentUser}>
                  {currentUser?.user?.company_user_firstname} {currentUser?.user?.company_user_lastname}
                </span>
              </TitleContainer>
            </HeaderContainer>

            <Grid item xs={12}>
              <Stepper
                alternativeLabel
                activeStep={activeStep}
                connector={<ColorlibConnector />}
                className={styles.step}
              >
                {steps.map((label, index) => (
                  <Step
                    className={clsx({
                      activeStep: activeStep === index,
                    })}
                    key={label}
                    onClick={handleClick}
                  >
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid container spacing={4}>
        <div className={styles.bottom}>
          <div className={styles.form}>
            <ViewStep />
          </div>
        </div>
      </Grid>
      <CancellationDialog
        title={isUpdateJob ? text.all.cancel_edit_parcels : text.all.cancel_new_parcels}
        message={isUpdateJob ? text.all.cancel_update_parcels_message : text.all.cancel_new_parcels_message}
        open={openDialog}
        onClose={handleCloseModal}
        onConfirm={onConfirmCancel}
      />
    </div>
  );
}
